import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './portal/service-dashboard/landing-page/landing-page.component';
import { ChangeLogComponent } from './software-services/change-log/change-log.component';
import { SeoDashboardSettingsComponent } from './software-services/search-engine-optimization/seo-dashboard-settings/seo-dashboard-settings.component';
import { SeoDashboardComponent } from './software-services/search-engine-optimization/seo-dashboard/seo-dashboard.component';
import { SmmDashboardSettingsComponent } from './software-services/social-media-marketing/smm-dashboard-settings/smm-dashboard-settings.component';
import { SmmDashboardComponent } from './software-services/social-media-marketing/smm-dashboard/smm-dashboard.component';
import { WebsiteDashboardSettingsComponent } from './software-services/website-package/website-dashboard-settings/website-dashboard-settings.component';
import { WebsiteDashboardComponent } from './software-services/website-package/website-dashboard/website-dashboard.component';
import { AuthenticationService } from './user/authentication.service';
import { CreateOnlineResumeComponent } from './resume/create-online-resume/create-online-resume.component';

const routes: Routes = [
  // app-routing.module.ts Components should have Breadcrumbs at the top
  { path: '', component: LandingPageComponent },
  { path: 'website', component: WebsiteDashboardComponent },
  { path: 'website/settings', component: WebsiteDashboardSettingsComponent },
  { path: 'seo', component: SeoDashboardComponent },
  { path: 'seo/settings', component: SeoDashboardSettingsComponent },
  { path: 'smm', component: SmmDashboardComponent },
  { path: 'smm/settings', component: SmmDashboardSettingsComponent },
  { path: 'change-log', component: ChangeLogComponent },

  { path: 'resume', component: CreateOnlineResumeComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { 
  constructor(private auth: AuthenticationService) {
  }
}
